module.exports = __webpack_public_path__ + "static/media/regalo4.97fc7fba.svg";